<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          :heading="table.name"
        />
        <base-material-card
          color="primary"
          icon="mdi-file-document"
          inline
        >
          <template v-slot:after-heading>
            <div class="text-h3 font-weight-light">
              {{ table.name }}
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              :footer-props="datatable_footer"
              show-group-by
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.search"
                          label="Поиск"
                          @input="load"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.id"
                          label="Идентификатор"
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox
                          v-model="form.all"
                          label="Показывать удаленные"
                          @change="load"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2">
                        <v-btn
                          color="secondary"
                          dark
                          min-width="250"
                          @click="clear"
                        >
                          Сбросить фильтры
                        </v-btn>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="warning"
                          min-width="250"
                          @click="show_import_dialog"
                        >
                          Импортировать
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  v-if="!item.readonly && ($store.state.access[9][3] || $store.state.access[9][4] && item.creator && item.creator.id == $store.state.user.id)"
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/entity/' + table.table + '/view?id=' + item.id)"
                >
                  mdi-cog
                </v-icon>
                <v-icon
                  v-else
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/entity/' + table.table + '/view?id=' + item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <template v-slot:item.date="{ item }">
                {{ format_date(item.date) }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="$store.state.access[9][5]"
              color="primary"
              min-width="100"
              @click="$router.push('/entity/' + table.table + '/create')"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.import.show"
      width="600"
    >
      <v-card>
        <v-card-title>Импорт записей</v-card-title>
        <v-card-text>
          <v-row
            v-for="(field, index) in table.fields"
            :key="index"
          >
            <v-col cols="6">
              <v-text-field
                v-model="dialog.import.data[field.key].name"
                :label="field.name"
              />
            </v-col>
            <v-col cols="6">
              <v-checkbox
                v-model="dialog.import.data[field.key].enable"
                label="Активен"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="dialog.import.file"
                accept=".csv"
                label="Загрузка файла"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="success"
            min-width="150"
            @click="import_data"
          >
            Импортировать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      loading: false,
      dialog: {
        import: {
          show: false,
          data: {

          },
          file: null
        }
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      sheet: false,
      sheetmenu: true,
      headers: [

      ],
      items: [],
      table_options: {

      },
      total: 0,
      form: {
        page: 1,
        limit: 30
      },
      select: {
      },
      dict: {
      },
      table: {
        name: '',
        fields: []
      }
    }),
    watch: {
      '$route.params.entity': function () {
        this.load()
      },
      table_options: {
        handler () {
          console.log(this.table_options)
          this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
          this.load()
        },
        deep: true,
      },
    },
    mounted: function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      this.load()
    },
    methods: {
      import_data: function () {
          const data = new FormData()
          data.append('file', this.dialog.import.file)
          data.append('form', JSON.stringify(this.dialog.import.data))
          this.axios
            .post('/api/entity/' + this.$route.params.entity + '/import', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              this.dialog.import.show = false
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                this.load()
              }
            })
            .catch(error => {
              this.dialog.import.show = false
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
      show_import_dialog: function () {
        this.dialog.import.show = true
      },
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function () {
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        this.form.page = page
        this.form.limit = itemsPerPage
        this.form.sortBy = sortBy
        this.form.sortDesc = sortDesc
        this.axios.post('/api/entity/' + this.$route.params.entity + '/list', this.form)
          .then(result => {
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              this.table = result.data.table || {}
              this.dialog.import.data = {}
              this.total = result.data.count
              for (const x in this.table.fields) {
                this.dialog.import.data[this.table.fields[x].key] = {
                  enable: true,
                  name: this.table.fields[x].key
                }
              }
              this.headers = []
              this.headers.push({
                sortable: false,
                text: 'Действия',
                value: 'action',
              })
              for (const x in this.table.fields.filter(a => a.show)) {
                this.headers.push({
                  text: this.table.fields.filter(a => a.show)[x].name,
                  value: 'data[' + this.table.fields.filter(a => a.show)[x].key + ']'
                })
              }
              this.loading = false
            }
          })
          .catch(e => {
            this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
